import { render } from "./JobsKpis.vue?vue&type=template&id=c4e15b1c&scoped=true"
import script from "./JobsKpis.vue?vue&type=script&lang=js"
export * from "./JobsKpis.vue?vue&type=script&lang=js"

import "./JobsKpis.vue?vue&type=style&index=0&id=c4e15b1c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4e15b1c"]])

export default __exports__